import dayjs from 'dayjs';
import { calculateMonthlyData } from './calculateMonthlyData';

/**
 * Set data for the subscription chart based on subscriptions.
 * @param {Object} params - Parameters for setSubscriptionChart function.
 * @param {Array} params.subscriptions - Subscription data.
 * @param {Function} params.setItems - State setter for chart items.
 * @param {Function} params.t - Translation function.
 * @param {string|Date} params.statisticsDate - Date used for statistics calculation.
 * @returns {void}
 */
export const setSubscriptionChart = ({
  subscriptions,
  setItems,
  t,
  statisticsDate
}) => {
  /**
   * Object to store statistics for N-1 and N years.
   * @type {Object}
   */

  const statistics = {
    'N-1': subscriptions?.filter(
      ({ payment_date, status }) =>
        dayjs(payment_date).isSame(
          dayjs(statisticsDate).subtract(1, 'year'),
          'year'
        ) && status === 'PAID'
    ),
    N: subscriptions?.filter(
      ({ payment_date, status }) =>
        dayjs(payment_date).isSame(dayjs(statisticsDate), 'year') &&
        status === 'PAID'
    )
  };

  // Calculate monthly data from statistics
  calculateMonthlyData({ dataByKey: statistics, setItems, t });
};
